<script lang="ts">
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from '../../../../../services/http';

	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';

	//Helpers
	import { onSettingsResponse } from '../../../../../helpers/device_settings_helpers';

	//Types
	import type { SettingRequest } from '../../../../..//types/requests/settings/setting';
	import type { Device } from '../../../../../types/Device';
	import type { InputClickEvent } from '../../../../../types/InputClickEvent';

	//Design system components
	import { Toggle, Alert } from '@Shelly/shelly-design-system';

	export let device: Device;

	let settings = readDeviceSettings(device.id);
	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore ?? settings;

	let fcEnabled = settings?.thermostats[0]?.force_close;
	let fcLoading = false;
	let extraPressure = settings?.thermostats[0]?.extra_pressure;
	let epLoading = false;

	const sendFCRequest = async (e: InputClickEvent) => {
		fcLoading = true;
		fcEnabled = e.target.checked;
		const res: SettingRequest = await postReq(
			`/device/generic_command`,
			{
				id: device.id,
				command: `force_close`,
				payload: JSON.stringify({
					enabled: fcEnabled,
				}),
			},
			20000,
		);

		if (!res?.isok) {
			fcEnabled = !fcEnabled;
		}

		onSettingsResponse(res, device);
		fcLoading = false;
	};

	const sendEPRequest = async (e: InputClickEvent) => {
		epLoading = true;
		extraPressure = e.target.checked;
		const res: SettingRequest = await postReq(
			`/device/generic_command`,
			{
				id: device.id,
				command: `extra_pressure`,
				payload: JSON.stringify({
					enabled: extraPressure,
				}),
			},
			20000,
		);

		if (!res.isok) {
			extraPressure = !extraPressure;
		}

		onSettingsResponse(res, device);
		epLoading = false;
	};
</script>

<Toggle
	size="m"
	class="mb-xs"
	disabled={fcLoading}
	checked={fcEnabled}
	on:click={sendFCRequest}
	id="toggle-7wzqcll"
>
	{$format('enable_fc_description', { default: 'Enable force close' })}
</Toggle>
<Alert
	class="mb-s"
	heading={$format('sub_settings_title_force_close', {
		default: 'Force close',
	})}
	message={$format('trv_fc_description', {
		default: 'If activated, the TRV will apply extra force when the shaft is completely closed.',
	})}
	isHeadingBold
/>

<Toggle
	size="m"
	class="mb-xs"
	disabled={epLoading}
	checked={extraPressure}
	on:click={sendEPRequest}
	id="toggle-kvlmzsr"
>
	{$format('label_enable_extra_pressure', { default: 'Enable extra pressure' })}
</Toggle>

<Alert
	type="warning"
	heading={$format('alert_warn_heading_extra_pressure', {
		default: 'Extra pressure',
	})}
	message={$format('alert_warn_message_extra_pressure', {
		default:
			'If activated, the TRV will use extra power throughout the whole movement(may increase noise during movement).',
	})}
	isHeadingBold
/>
